
import React from "react";
import Nav from "../../Nav";
import { Container, Typography, Box, Card, CardContent, CardMedia, Button, List, ListItem, ListItemText, Grid } from '@mui/material';
import blog1 from "../images/card4.webp";
import pr1 from "../images/eng1.jpeg";
import pr2 from "../images/eng2.webp";
import { motion } from 'framer-motion';




const GrammarCard4 = ({ post }) => {

    return (
        <>
            <Nav />
            <Box sx={{ backgroundColor: '#f8fafc', py: 8, fontFamily: 'Arial, sans-serif' }}>
                <Box sx={{ py: 15, textAlign: 'center', color: '#000000' }} style={{ backgroundColor: '#f8fafc' }}>
                    <Container maxWidth="lg" style={{ backgroundColor: '#f8fafc' }}>
                        <Typography variant="h3" align="center" className='merriweather-bold' gutterBottom sx={{ fontWeight: 'bold' }}>
                            Which verbs aren’t interchangeable in English?
                        </Typography>
                        <div id="image-container" className="absolute top-20 left-0">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-13.png' className="ml-4 mt-4" alt="Small Image" />
                        </div>
                        <div id="image-container2" className="absolute top-20 right-80">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/07/shape-37.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute top-120 right-40">
                            <img src='https://demo.edublink.co/wp-content/uploads/2023/05/shape-02.png' className="h-32 w-32" alt='' />
                        </div>
                        <div id="image-container3" className="absolute bottom-20 right-0">
                            <img src='https://demo.edublink.co/wp-content/themes/edublink/assets/images/shapes/breadcrumb-shape-3.png' className="h-48 w-32" alt='' />
                        </div>
                    </Container>
                </Box>

                <Container maxWidth="lg" sx={{ backgroundColor: '#ffffff', p: 5, borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', mt: -8 }}>
                    <Grid container spacing={5} alignItems="flex-start" mb={4}>
                        <Grid item xs={12} lg={6}>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                In English, certain verbs are not interchangeable because they convey specific meanings or actions that cannot be replaced by other verbs without altering the intended message.
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                Verbs that are not generally interchangeable often have unique connotations, nuances, or collocations that make them distinct from other verbs. For example:
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                Run, Walk, Jog: These verbs describe different modes of movement and cannot be used interchangeably without changing the action being described.
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                Eat, Drink, Consume: While they all involve ingesting something, each verb carries its own specific meaning and usage.
                            </Typography>
                            <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                                Read, Write, Speak: These verbs involve different modes of communication and cannot be substituted for each other without changing the intended action.
                            </Typography>

                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ duration: 0.5, delay: 0.2 }}>
                                <CardMedia
                                    component="img"
                                    image={blog1}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}
                                />
                            </motion.div>
                        </Grid>
                    </Grid>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        Sleep, Nap, Rest: Each of these verbs describes different states or durations of rest, and they are not interchangeable in most contexts.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        Buy, Sell, Trade: These verbs describe different actions related to transactions and cannot be substituted for each other without altering the meaning.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        Love, Like, Enjoy: While they all express positive feelings, each verb conveys a different degree or quality of affection or preference.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        Drive, Fly, Sail: These verbs describe different modes of transportation and cannot be used interchangeably without changing the mode of travel being described.
                    </Typography>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        Open, Close, Shut: Each of these verbs describes a specific action related to the state of something being open or closed, and they cannot be substituted for each other without altering the meaning.
                    </Typography>
                    <Grid item xs={12} lg={11} container spacing={2}>
                        <Grid item xs={6} paddingBottom={'20px'}>
                            <motion.div
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                            >
                                <CardMedia
                                    component="img"
                                    image={pr1}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2 }}
                                />
                            </motion.div>
                        </Grid>
                        <Grid item xs={6}>
                            <motion.div
                                initial={{ scale: 0 }}
                                animate={{ scale: 1 }}
                                transition={{ duration: 0.5, delay: 0.2 }}
                            >
                                <CardMedia
                                    component="img"
                                    image={pr2}
                                    alt="Fresh Start"
                                    sx={{ borderRadius: 2 }}
                                />
                            </motion.div>
                        </Grid>
                    </Grid>
                    <Typography variant="body1" paragraph sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}>
                        These are just a few examples, but in general, verbs that describe distinct actions, states, or processes are not interchangeable in English.
                    </Typography>
                </Container >
            </Box >
        </>
    );
};

export default GrammarCard4;
